"use client"

import { useState, useEffect } from "react"
import { Container } from "react-bootstrap"
import "../components/styles/Client.css"

function Clients() {
  const [currentSlide, setCurrentSlide] = useState(0)

  const clients = [
    {
      name: "MS Geotech",
      logo: "/images/clients/ms-geotech.png",
    },
    {
      name: "SS Industries",
      logo: "/images/clients/ss-industries.png",
    },
    {
      name: "Sharat Industries",
      logo: "/images/clients/sharat-industries.png",
    },
    {
      name: "Prakash Enterprises",
      logo: "/images/clients/prakash-enterprises.png",
    },
    {
      name: "Onsite Rental",
      logo: "/images/clients/onsite-rental.png",
    },
  ]

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prevSlide) => (prevSlide === clients.length - 1 ? 0 : prevSlide + 1))
    }, 3000)

    return () => clearInterval(timer)
  }, [clients.length])

  return (
    <section className="clients-section">
      <Container>
        <h2 className="section-title text-center mb-5">Our Clients</h2>
        <div className="clients-slider">
          <div className="clients-track" style={{ transform: `translateX(-${currentSlide * 100}%)` }}>
            {clients.map((client, index) => (
              <div key={index} className="client-slide">
                <img src={client.logo || "/placeholder.svg"} alt={client.name} className="client-logo" />
              </div>
            ))}
          </div>
          <div className="slider-dots">
            {clients.map((_, index) => (
              <button
                key={index}
                className={`slider-dot ${currentSlide === index ? "active" : ""}`}
                onClick={() => setCurrentSlide(index)}
              />
            ))}
          </div>
        </div>
      </Container>
    </section>
  )
}

export default Clients

